import React from 'react'
import {format, addDays, isSameDay} from 'date-fns'
import {Line} from '../utilline'
import {ConstraintDay} from '../caltypes'
import {is_hoyoshitsu_busy4} from '../helpers'
// '通夜H' を 安置と同様に... 2025-0417
const fmt = (dt: Date) => format(dt, 'yyyy-MM-dd')

//
// ●2025 法要室 H 向け 1,2,3,4日の葬儀期間の選択
// disabled={readonly || line.reason.indexOf('2日')<0} この部分は再考しよう。なぜdisable
// 
// @2024-1216 (はるばる) cdaysを得る。sigh...
//
export const SogiOption4 = ({line, readonly, cdays}: {line: Line; readonly: boolean; cdays: ConstraintDay[]}) => {
  const [option, setOption] = React.useState(line.option)
  const [busy4, setBusy4] = React.useState(is_hoyoshitsu_busy4({dt: new Date(line.row.date), cdays}))

  const handle = (e: React.ChangeEvent<HTMLInputElement>) => {
    line.option = e.target.value
    setOption(e.target.value)
  }

  //
  return (<>
  <div className="input-group">
    <label className="input-group-text">期間</label>

    {/* 1日 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='1日'} value={'1日'}
        disabled= {readonly || busy4.d1}
        onChange={handle}
      />
      <span className="ms-0">{'1日'}</span>
    </label>

    {/* 2日 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='2日'} value={'2日'}
        disabled= {readonly || busy4.d2}
        onChange={handle}
      />
      <span className="ms-0">{'2日'}</span>
    </label>

    {/* 3日 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='3日'} value={'3日'}
        disabled= {readonly || busy4.d3}
        onChange={handle}
      />
      <span className="ms-0">{'3日'}</span>
    </label>

    {/* 4日 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='4日'} value={'4日'}
        disabled= {readonly || busy4.d4}
        onChange={handle}
      />
      <span className="ms-0">{'4日'}</span>
    </label>
  </div>

  </>)
}
